namespace $.$$ {

	$mol_style_define( $bog_vmap_app_history, {

		flex: { basis: '20rem', grow: 0, shrink: 1 },
		minWidth: '14rem',

	} )

}
